import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { GamesGroupQuery, GamesGroupService, GroupType, IGroupSummary, PredictorProcessStatus, ProgressStatus } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgbcl-games-group-item',
  templateUrl: './games-group-item.component.html',
  styleUrl: './games-group-item.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class GamesGroupItemComponent implements OnInit {
  @Input() gameGroupItem!: IGroupSummary;
  @Input() groupType: GroupType;
  groupTypes = GroupType;
  gamePlayStatus = ProgressStatus;
  predictorStatuses = PredictorProcessStatus;
  @Output() sortGamesEmitter = new EventEmitter<any>();
  @Output() comingSoonEndEmitter = new EventEmitter<any>();
  @Output() gameEndedEmitter = new EventEmitter<any>();
  @ViewChild('content', { static: true }) content: ElementRef;
  constructor(
    private modalService: NgbModal,
    private gamesGroupService: GamesGroupService,
    public gamesGroupQuery: GamesGroupQuery
  ) {}
  ngOnInit(): void {}

  /**
  get button Label by status
   */
  getStatusLabel(status: ProgressStatus) {
    switch (status) {
      case ProgressStatus.NotStarted:
        return 'fgbcl.game.play.button.text';
      case ProgressStatus.InProgress:
        return 'fgbcl.game.resume.button.text';
      case ProgressStatus.Completed:
        return 'fgbcl.game.view.button.text';
      default:
        return 'fgbcl.game.play.button.text';
    }
  }

  fetchGroupSummary() {
    this.gamesGroupService.fetchGroupById(this.gameGroupItem.GroupId).subscribe((group) => {
      this.gameGroupItem = group;
      this.sortGamesEmitter.emit(this.gameGroupItem);
    });
  }

  /**
   * open model to play game
   */
  openModal() {
    this.modalService.open(this.content, {
      centered: true,
      backdrop: false,
      windowClass:
        this.groupType == this.groupTypes.Predictor
          ? 'game-item-model-custom-style .modal-dialog game-predictor-model-background'
          : 'game-item-model-custom-style .modal-dialog game-trivia-model-background',
    });
  }

  comingSoonEnd(event: any, groupId: number) {
    if (event) {
      this.comingSoonEndEmitter.emit({ completed: true, groupId: groupId });
    }
  }

  gameEnded(event: any, groupId: number) {
    if (event) {
      this.gameEndedEmitter.emit({ completed: true, groupId: groupId });
    }
  }

  closeModal() {
    this.fetchGroupSummary();
    this.modalService.dismissAll();
  }
}
